/** Site URL for the mulebuyspreadsheet.today website */
const siteUrl: string = "https://mulebuyspreadsheet.today";

export default siteUrl;